module.exports = "/_next/static/bg_profile_small.png";